import React from 'react';
import type { FC } from 'react';
import { styled } from '@material-ui/core';

interface Props {
  readonly hiddenCount: number;
}

const StyledNotice = styled('div')({
  textAlign: 'center',
  fontSize: '12px',
  color: 'rgba(0, 0, 0, 0.6)'
});

const SidebarFilterNotice : FC<Props> = ({ hiddenCount }) => {
  const hasHidden = hiddenCount > 0;
  const isPlural = hiddenCount > 1;
  const resultWord = isPlural ? 'results' : 'result';
  const article = isPlural ? 'are' : 'is';

  if (hasHidden) {
    return (
      <StyledNotice>
        { hiddenCount } { resultWord } { article } hidden
      </StyledNotice>
    );
  } else {
    return null;
  }
};

export default SidebarFilterNotice;
